import { EstimatedTransitTime } from '@pelicargo/types';

export const ETT_SORT_ORDER: Record<EstimatedTransitTime, number> = {
  [EstimatedTransitTime.OneToTwoDays]: 1,
  [EstimatedTransitTime.TwoToThreeDays]: 2,
  [EstimatedTransitTime.ThreeToFourDays]: 3,
  [EstimatedTransitTime.FourToFiveDays]: 4,
  [EstimatedTransitTime.FiveToSixDays]: 5,
  [EstimatedTransitTime.SixToSevenDays]: 6,
  [EstimatedTransitTime.SevenDaysPlus]: 7,
};
